import React from 'react'
import { useEffect, useState } from "react";
// import { auth } from "../firebase/firebase-config";
import firebase from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import SingleUser from '../SingleUser/SingleUser';
import { Col, Row } from 'react-bootstrap';

function VerificationPage() {
    const [all_users, setall_users] = useState([])
    // const [user, loading] = useAuthState(auth);
    const [all_pendingverifications, setall_pendingverifications] = useState([])
    const [all_Approvedverifications, setall_Approvedverifications] = useState([])
    const [query, setquery] = useState('')
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };



    const get_all_orders = () => {
        firebase.firestore().collection('users').onSnapshot((users) => {
            const users_data = [];
            users.forEach(element => {
                users_data.push(element.data());
            })
            setall_users(users_data);

        })
        firebase.firestore().collection('users').where('visaIdVerificationState', '==', 'pending').onSnapshot((order) => {
            const Pendingorders_data = [];
            order.forEach(element => {
                Pendingorders_data.push(element.data());
            });
            setall_pendingverifications(Pendingorders_data);

        })
        firebase.firestore().collection('users').where('visaIdVerificationState', '==', 'verified').onSnapshot((order) => {
            const Approvedorders_data = [];
            order.forEach(element => {
                Approvedorders_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setall_Approvedverifications(Approvedorders_data);

        })


    }
    useEffect(() => {
        get_all_orders();
    }, []);

    const search = (data) => {
        return data.filter((order_search) => order_search.orderId.toLowerCase().includes(query) || order_search.isCompleted.toLowerCase().includes(query) || order_search.products.toLowerCase().includes(query) || order_search.contact.toLowerCase().includes(query)

        );
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className="d-flex justify-content-center  mt-4 align-items-center">
                    <button
                        className={toggleState === 1 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(1)}
                    >
                        Pending Verifications({all_pendingverifications.length})
                    </button>
                    <button
                        className={toggleState === 2 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(2)}
                    >
                        Verified Verifications ({all_Approvedverifications.length})
                    </button>

                </Row>

                <div className='mt-4'>
                    <div className="content-tabs">
                        <div className={toggleState === 1 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_pendingverifications.filter(user => user.id.toLowerCase().includes(query)).map((userData, i) => (


                                    <SingleUser data={userData} verificationPage={true} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 2 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Approvedverifications.filter(user => user.id.toLowerCase().includes(query)).map((userData, i) => (


                                    <SingleUser data={userData} verificationPage={true} key={i} />


                                ))}
                            </div>
                        </div>


                    </div>

                </div>


            </div>

        </>
    )
}

export default VerificationPage